import { createElement, useState, useEffect, useRef, memo } from '@max/max';
import LImage from '@max/leez-image';
import View from '@hfe/max-view';
import { Vap } from '@lingbo/effects/extend/alphaVideo';
import './index.scss';
import { getFullScreenSize } from '../../utils/layout';
const WebVapView = (props) => {
    const { mtapConfigJson, mp4, loop = true, width, height, keepLastFrame, widthHeightRatio, widthInRpx, autoPlay = true } = props;
    const animRef = useRef(null);
    const bgImgRef = useRef(null);
    const [vapFail, setVapFail] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const { width: widthInPx, toRateSize } = getFullScreenSize();
    const fallbackTimer = useRef(null);
    const vap = useRef(null);
    const timers = useRef([]);
    const prevConfig = useRef({
        mtapConfigJson: props.mtapConfigJson,
        mp4: props.mp4
    });
    function clearTimers() {
        timers.current.forEach(t => clearTimeout(t));
    }
    useEffect(() => {
        try {
            if (vap.current) {
                vap.current?.destory();
                vap.current = null;
                if (fallbackTimer.current)
                    clearTimeout(fallbackTimer.current);
            }
            const canvasWidth = widthInRpx ? toRateSize(widthInRpx) : widthInPx;
            if (animRef.current) {
                vap.current = new Vap({
                    container: animRef.current,
                    src: mp4,
                    vapOptions: mtapConfigJson,
                    loop,
                    keepLastFrame,
                    autoPlay,
                    isAudio: false,
                    isVideo: false
                }, widthHeightRatio ? {
                    width: canvasWidth,
                    height: canvasWidth / widthHeightRatio,
                    pixel: window?.devicePixelRatio || 10
                } : undefined);
            }
            vap.current?.on('loaded', () => {
                setLoaded(true);
                vap.current.play();
                props.onStart?.();
                if (props.playPointActions) {
                    props.playPointActions.forEach(({ microseconds, action }) => {
                        const t = setTimeout(() => {
                            action();
                        }, microseconds);
                        timers.current.push(t);
                    });
                }
            });
            vap.current?.on('end', () => {
                props.onVideoEnd?.();
            });
        }
        catch (e) {
            vap.current?.destory();
            setVapFail(true);
            props.onFallback?.();
            clearTimers();
        }
        return () => {
            vap.current?.destory();
            clearTimers();
            setVapFail(true);
        };
    }, []);
    useEffect(() => {
        if (prevConfig.current?.mtapConfigJson === props.mtapConfigJson && prevConfig.current.mp4 === props.mp4) {
            return;
        }
        prevConfig.current = {
            mtapConfigJson: props.mtapConfigJson,
            mp4: props.mp4
        };
        vap.current?.updateVideo({
            src: props.mp4,
            vapOptions: props.mtapConfigJson,
            loop: props.loop
        });
    }, [props.mtapConfigJson, props.mp4]);
    return <>
      {props.cover && (vapFail || !loaded) ? <View ref={bgImgRef}>
            <LImage className='vapImageFilter' widthHeightRatio={props.widthHeightRatio} style={{
        width,
        height,
        ...props.style
    }} source={{
        uri: props.cover
    }} resizeMode='cover'/>
          </View> : null}
      <View className='vapContainer' style={{
        width,
        height,
        ...props.style,
        pointerEvents: 'none'
    }} ref={animRef}/>
    </>;
};
export default memo(WebVapView);
